import { useContext } from "react";
import { IonInput, IonItem, IonLabel, IonNote } from "@ionic/react";
import { TranslationsContext } from "../util/Translations";
import { useSettingsStore } from "../store/settings";
import {
  DEFAULT_CYCLE_COUNT_ITEM_LIMIT,
  MAX_CYCLE_COUNT_ITEM_LIMIT,
} from "../hooks/useDownloadCycleCountsForOfflineAccess";

/**
 * Device-local setting for the maximum number of cycle-count items to download
 * for offline access. Defaults to DEFAULT_CYCLE_COUNT_ITEM_LIMIT; the user can
 * lower/raise it based on their device's storage.
 */
const CycleCountItemLimit: React.FC = () => {
  const { translations } = useContext(TranslationsContext);
  const itemLimit = useSettingsStore((state) => state.cycleCountItemLimit);
  const setItemLimit = useSettingsStore((state) => state.setCycleCountItemLimit);

  const handleChange = (value?: string | number | null) => {
    if (value === "" || value === null || value === undefined) {
      setItemLimit(undefined); // fall back to the default
      return;
    }
    const parsed = Number(value);
    if (!Number.isNaN(parsed) && parsed > 0) {
      // never allow more than the max (device storage protection)
      setItemLimit(Math.min(Math.floor(parsed), MAX_CYCLE_COUNT_ITEM_LIMIT));
    }
  };

  return (
    <IonItem>
      <IonLabel position="stacked">
        {translations["lbl_cyclecount_item_limit"] ||
          "Cycle Count Offline Item Limit"}
      </IonLabel>
      <IonInput
        type="number"
        inputmode="numeric"
        min="1"
        max={MAX_CYCLE_COUNT_ITEM_LIMIT}
        value={itemLimit}
        placeholder={String(DEFAULT_CYCLE_COUNT_ITEM_LIMIT)}
        onIonChange={(ev) => handleChange(ev.detail.value)}
      />
      <IonNote slot="helper">
        {translations["lbl_cyclecount_item_limit_help"] ||
          `Items downloaded for offline counting. Default ${DEFAULT_CYCLE_COUNT_ITEM_LIMIT}, max ${MAX_CYCLE_COUNT_ITEM_LIMIT}.`}
      </IonNote>
    </IonItem>
  );
};

export default CycleCountItemLimit;
